import { type TranslationTree } from '@/i18n/types';

export const messages = {
  close: 'Fechar',
} satisfies TranslationTree;
